import { useQuery } from '@apollo/client';
import { useCallback } from 'react';
import type { GetMessagePage, GetMessagePageVariables } from 'types/graphql';
import AiChatApi from '../api/AiChat.api';

export type LoadMessagesOptions = {
  conversationId: number;
  first?: number;
  after?: string | null;
  sortDirection?: 'asc' | 'desc';
};

export type LoadMessagesResult = { messages: any[]; pageInfo: { endCursor: string | null; hasNextPage: boolean } };

export function useLoadMessages() {
  const { refetch: getMessagePage } = useQuery<GetMessagePage, GetMessagePageVariables>(AiChatApi.GetMessagePage, {
    skip: true,
  });

  const loadMessages = useCallback(
    async ({
      conversationId,
      first = 20,
      after = null,
      sortDirection = 'desc',
    }: LoadMessagesOptions): Promise<LoadMessagesResult> => {
      const result = await getMessagePage({
        input: { conversationId, first, after, sortItems: [{ field: 'createdAt', sort: sortDirection }] },
      });

      const edges = result.data?.messagePage?.edges || [];
      const messages = edges.map((edge) => edge.node);
      const pageInfo = {
        endCursor: result.data?.messagePage?.pageInfo?.endCursor || null,
        hasNextPage: result.data?.messagePage?.pageInfo?.hasNextPage || false,
      };

      return { messages, pageInfo };
    },
    [getMessagePage]
  );

  return { loadMessages };
}
